<template>
  <BaseDialog centered contentClass="add-normalized-name" ref="dialog" :show-actions="true">
    <template slot="title">{{ $t('page.admin-tenant.normalized-names.add-dialog.title') }}</template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <NameSuggestion
          ref="nameSuggestionRef"
          :suggestions="suggestions"
          :loading="pending"
          @updated-selected-names="updateSelectedNames"
          @on-search="onSearch"
        />
        <div class="add-normalized-name__actions">
          <FormButton is-outlined class="add-normalized-name__cancel" @click.native="cancelClick">{{
            $t('actions.cancel')
          }}</FormButton>
          <FormButton @click.native="onSubmit" type="submit" :disabled="isFormInvalid">
            <span>{{ $t('actions.addWithCount', { count: addedNormalizedNames.length }) }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FormButton from '@/components/form/FormButton.vue';
import BaseDialog from '@/components/base/BaseDialog';
import NameSuggestion from '@/views/business-intelligence/NameSuggestion.vue';

export default {
  name: 'AddNormalizedNameDialog',
  components: {
    FormButton,
    BaseDialog,
    NameSuggestion,
  },
  data() {
    return {
      addedNormalizedNames: [],
      defaultSuggestions: [],
      suggestions: [],
    };
  },
  computed: {
    ...mapGetters('biDashboard', ['pending']),
    isFormInvalid() {
      return this.addedNormalizedNames.length === 0;
    },
  },
  methods: {
    ...mapActions('biDashboard', [
      'getTenantNormalizedNameSuggestion',
      'getNormalizedNameSuggestion',
      'addTenantNormalizedNameMany',
    ]),
    open() {
      this.addedNormalizedNames = [];
      this.$refs.dialog.openModal();

      this.refreshSuggestions();
    },
    close() {
      this.$refs.nameSuggestionRef.reset();
      this.$refs.dialog.isModalOpen = false;
    },
    refreshSuggestions() {
      this.getTenantNormalizedNameSuggestion().then((response) => {
        this.suggestions = response;
        this.defaultSuggestions = response;
      });
    },
    onSearch(input) {
      if (input.length > 0) {
        this.getNormalizedNameSuggestion(input).then((response) => (this.suggestions = response));
      } else {
        this.suggestions = this.defaultSuggestions;
      }
    },
    updateSelectedNames(names) {
      this.addedNormalizedNames = names;
    },
    onSubmit() {
      this.addTenantNormalizedNameMany(this.addedNormalizedNames)
        .then(() => {
          this.$toast.success(
            this.$tc('page.admin-tenant.normalized-names.add-dialog.add-success', this.addedNormalizedNames.length),
          );
          this.$emit('action-succeeded');
        })
        .catch((error) => this.$toast.error(error));
      this.close();
    },
    cancelClick() {
      this.close();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__add-normalized-name {
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 8px 32px 32px 32px !important;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}
.add-normalized-name {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }

  &__action {
    text-transform: lowercase;
    font-weight: bold;
  }
}
</style>
